import React from 'react';
import { m } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import Link from 'next/link';

export const CTA = () => {
    return (
        <section className="border-t border-neutral-100 py-28 bg-[#FAFAFA]">
            <div className="max-w-3xl mx-auto px-6 text-center">
                <m.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <h2 className="text-4xl sm:text-5xl font-bold text-neutral-900 mb-5 tracking-tight leading-[1.1]">
                        Built for the future.<br />
                        <span className="text-neutral-400">Available today.</span>
                    </h2>

                    <p className="text-lg text-neutral-500 mb-10 max-w-xl mx-auto leading-relaxed">
                        Join 500+ businesses running their entire sales and marketing operation on Axist AI agents.
                    </p>

                    <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                        <Link href="/login?mode=signup">
                            <m.button
                                className="px-8 py-3.5 bg-neutral-900 hover:bg-neutral-800 text-white font-semibold rounded-lg transition-colors flex items-center gap-2 group text-[15px] cursor-pointer"
                                whileHover={{ scale: 1.01 }}
                                whileTap={{ scale: 0.99 }}
                            >
                                Get started free
                                <ArrowRight size={16} className="group-hover:translate-x-0.5 transition-transform" />
                            </m.button>
                        </Link>
                        <Link href="/pricing">
                            <button className="px-8 py-3.5 border border-neutral-200 hover:border-neutral-300 hover:bg-white text-neutral-700 font-semibold rounded-lg transition-colors text-[15px] cursor-pointer">
                                View pricing
                            </button>
                        </Link>
                    </div>

                    <p className="mt-6 text-sm text-neutral-400">
                        No credit card required · Cancel anytime
                    </p>
                </m.div>
            </div>
        </section>
    );
};
